export const useAutocompleteNavigation = ({ isOpen, suggestions, activeIndex, setIsOpen, setActiveIndex, selectItem, }) => {
    const handleKeyDown = (e) => {
        if (!isOpen || suggestions.length === 0)
            return;
        switch (e.key) {
            case 'ArrowDown':
                e.preventDefault();
                setActiveIndex((prev) => prev < suggestions.length - 1 ? prev + 1 : 0);
                break;
            case 'ArrowUp':
                e.preventDefault();
                setActiveIndex((prev) => prev > 0 ? prev - 1 : suggestions.length - 1);
                break;
            case 'Enter':
                e.preventDefault();
                if (activeIndex >= 0 && activeIndex < suggestions.length) {
                    selectItem(suggestions[activeIndex]);
                }
                break;
            case 'Escape':
                setIsOpen(false);
                setActiveIndex(-1);
                break;
        }
    };
    const handleDropdownMouseDown = (e) => {
        e.preventDefault();
        setIsOpen((prev) => !prev);
    };
    return {
        handleKeyDown,
        handleDropdownMouseDown,
    };
};
